// extracted by mini-css-extract-plugin
export var Base = "RecommendedArticles-module--Base--ebf6e";
export var Left = "RecommendedArticles-module--Left--af5c0";
export var Pagination = "RecommendedArticles-module--Pagination--71230";
export var RecommendedWrap = "RecommendedArticles-module--RecommendedWrap--c97a6";
export var Right = "RecommendedArticles-module--Right--e2548";
export var RowSpacer = "RecommendedArticles-module--RowSpacer--cf166";